import { useContext } from 'react';

import Context from '../../Context';

export default function useDictateContext() {
  return useContext(Context);
}
